





































































































































































































import { Component} from 'vue-property-decorator';
import LegendUI from "@/components/map/LegendUI.vue";
import MapUI from "@/components/map/MapUI.vue";
import { IMapLayer } from "@/components/map/types";
import Map from "@/components/map/Map";
import Print from "./print.class";

@Component({
  components: {
    'ol-map': MapUI,
    'v-legend': LegendUI
  }
})
export default class PrintEcoplantMap extends Print {
  legendTitle:string = '';
  createLegend() {
    let legend:IMapLayer = null; //{};
    let legends = this.mapLegends;
    while (legends && !legend) {
      legends.forEach((ml) => {
        let i,yes = false;
        if (ml.mapSources) {
          for (i=0; i<ml.mapSources.length && !yes; i++) {
            let ms = ml.mapSources[i];
            yes = (ms.params && ms.params.LAYERS.match(/^ecoplant\:/i));
          }
        }
        if (yes) {
          legend = ml;
          return;
        }
        legends = ml.children || ml.legend;
      });
    }
    if (!!this.plant.match(/rice/i)) {
      this.legendTitle += ' (เริ่มปลูก/อายุ)';
    } else if (!!this.plant.match(/maize/i)) {
      this.legendTitle += ' (เริ่มปลูก/เก็บเกี่ยว)';
    } else {
      this.legendTitle += ' (เริ่มปลูก)';
    }
    if (legend.legend && legend.legend.length>0) {
      legend.legend.splice(0,1);
    }
    this.LegendItems = [{
      items: legend.legend.splice(0,8)
    }];
    while (legend.legend.length>0) {
      this.LegendItems.push({
        items: legend.legend.splice(0,8)
      });
    }
  }

  get plantName() : string {
    let pn = '';
    if (this.plant.match(/rice/i)) {
      pn = 'ข้าว';
    } else if (this.plant.match(/maize/i)) {
      pn = 'ข้าวโพด';
    } else if (this.plant.match(/cassava/i)) {
      pn = 'มันสําปะหลัง';
    } else if (this.plant.match(/sugarcane/i)) {
      pn = 'อ้อย';
    }
    return pn;
  }

  onMapCreated(map:Map) {
    this.$map = map;
    if (this.mapLayers) {
      if (this.mapFilter && this.mapFilter.ProvinceCode) {
        this.zoomToTambon();
      } else {
        this.adjustScale();
      }
      this.$map.createOverlayLayersAndControls(this.mapLayers);
    } else {
      this.adjustScale();
    }
    this.createLegend();
  }
}
